import { log, removeItem } from './Utils';
import store from '../redux/store';
import Actions from '../values/Actions';



export const HTTPRequest = async (url, headers, body) => {
	headers["Content-Type"] = "application/json"
	let method = 'POST'
	log("Request: {Url:" + url + ",Method:" + method + ",Headers:" + JSON.stringify(headers) + ",body:" + JSON.stringify(body) + "}");

	try {

		let response = await fetch(url, {
			//redirect: 'follow',
			method: method,
			headers: headers,
			body: JSON.stringify(body),
		});
		let responseJson = await response.json();

		if (response.status === 401) {
			removeItem('isUserLoggedIn')
			removeItem('userInfo')
			window.location.href = '/'
		}

		return {
			response: responseJson,
			status: response.status
		};


	} catch (e) {
		log("HTTP-ERROR : ", JSON.stringify(e))
		return {
			response: { message: "HTTP ERROR" },
			status: 500
		}
	}
}

export const HTTPPutRequest = async (url, headers, body) => {
	headers["Content-Type"] = "application/json"
	let method = 'PUT'
	log("Request: {Url:" + url + ",Method:" + method + ",Headers:" + JSON.stringify(headers) + ",body:" + JSON.stringify(body) + "}");

	try {

		let response = await fetch(url, {
			//redirect: 'follow',
			method: method,
			headers: headers,
			body: JSON.stringify(body),
		});
		let responseJson = await response.json();

		if (response.status === 401) {
			removeItem('isUserLoggedIn')
			removeItem('userInfo')
			window.location.href = '/'
		}

		return {
			response: responseJson,
			status: response.status
		};


	} catch (e) {
		log("HTTP-ERROR : ", JSON.stringify(e))
		return {
			response: { message: "HTTP ERROR" },
			status: 500
		}
	}
}

//  Delete Request
export const HTTPDeleteRequest = async (url, headers) => {
	headers["Content-Type"] = "application/json"
	let method = 'DELETE'
	// log("Request: {Url:" + url + ",Method:" + method + ",Headers:" + JSON.stringify(headers) + ",body:" + JSON.stringify(body) + "}");

	try {

		let response = await fetch(url, {
			method: method,
			headers: headers,
		});
		let responseJson = await response.json();

		if (response.status === 401) {
			removeItem('isUserLoggedIn')
			removeItem('userInfo')
			window.location.href = '/'
		}

		return {
			response: responseJson,
			status: response.status
		};


	} catch (e) {
		log("HTTP-ERROR : ", JSON.stringify(e))
		return {
			response: { message: "HTTP ERROR" },
			status: 500
		}
	}
}

export const HTTPFileUploadRequest = async (url, headers, body) => {
	log("Request: {Url:" + url + ",Headers:" + JSON.stringify(headers) + ",body:" + JSON.stringify(body) + "}");

	try {
		let response = await fetch(url, {
			redirect: 'follow',
			method: 'POST',
			headers: headers,
			body: createFormData(body),
		});
		//let responsetext = await response.text();
		//log("SSS",responsetext)
		let responseJson = await response.json();

		return {
			response: responseJson,
			status: response.status
		};;
	} catch (e) {
		log("HTTPERR", JSON.stringify(e.message))
		return {
			response: { message: "HTTP ERROR" },
			status: 500
		}
	}
}

const createFormData = (body) => {
	const data = new FormData();

	Object.keys(body).forEach(key => {
		data.append(key, body[key]);
	});
	log('FormData: ', data)
	//	alert('FormData: '+ JSON.stringify(data))
	return data;
};
export const HTTPGetRequest = async (url, headers) => {

	log("Request: {Url:" + url + ",Headers:" + JSON.stringify(headers) + "}");

	try {
		let response = await fetch(url, {
			method: "GET",
			headers: headers,
		});
		//let responseText = await response.text();
		//log("RESP-Text",JSON.stringify(responseText))
		let responseJson = await response.json();
		if (response.status === 401) {
			removeItem('isUserLoggedIn')
			removeItem('userInfo')
			store.dispatch({ type: Actions.LOGOUT })
			window.location.href = "/"


		}

		return {
			response: responseJson,
			status: response.status
		};

	} catch (e) {
		//log("HTTP-ERROR : ", JSON.stringify(e))
		return e;
	}
}

export const HTTPPostRequest = async (url, method, headers = null, body = null) => {
	// console.log("Request: {Url:" + url + ",Method:" + method + ",Headers:" + JSON.stringify(headers) + ",body:" + JSON.stringify(body) + "}");
	const extras = (method === 'POST') ? {
		headers: headers,
		body: JSON.stringify(body)
	} : ''
	try {
		let response = await fetch(url, {
			method: method,
			extras
		});
		let responseJson = await response.json();
		return {
			response: responseJson,
			status: response.status
		};
	} catch (e) {
		return e;
	}
}
/*
 try {
	let response = await fetch(
	  'https://facebook.github.io/react-native/movies.json'
	);
	let responseJson = await response.json();
	return responseJson.movies;
  } catch (error) {
	error(error);
  }

*/
export const HTTPPatchRequest = async (url, headers, body) => {
	log("Request: {Url:" + url + ",Headers:" + JSON.stringify(headers) + ",body:" + JSON.stringify(body) + "}");

	try {
		let response = await fetch(url, {
			redirect: 'follow',
			method: 'PATCH',
			headers: headers,
			body: createFormData(body),
		});
		//let responsetext = await response.text();
		//log("SSS",responsetext)
		let responseJson = await response.json();

		return {
			response: responseJson,
			status: response.status
		};;
	} catch (e) {
		log("HTTPERR", JSON.stringify(e.message))
		return {
			response: { message: "HTTP ERROR" },
			status: 500
		}
	}
}
